import React from 'react';
import { Link, useParams } from 'react-router-dom';

function PowerPerformBreadCrumb() {
  const {plantName, id} = useParams();
  const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={`/Powergenerationdashboard/${plantName.replace(
                    /\s+/g,
                    "-"
                  )}/${id}`} className="breadcrumb-link">Power Generation Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Power Generation Plant's Performance Data
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default PowerPerformBreadCrumb;
